import { Card, Stack, Typography, useTheme } from "@mui/material";
import CsvFileTypeImg from "assets/images/CsvFileType.webp";
import girlWithBook from "assets/images/girlWithBook.svg";
import XlsxFileTypeImg from "assets/images/XlsxFileType.webp";

export const StepZeroCustomersSelection = ({
  setCustomerCreationMethod,
  setCurrentStep,
}: {
  setCustomerCreationMethod: (method: "manual" | "bulk") => void;
  setCurrentStep: (step: number) => void;
}) => {
  const theme = useTheme();

  return (
    <Stack px="24px" gap="24px" width="100%">
      <Typography variant="h5">Let's onboard customers</Typography>
      <Stack gap="16px">
        {customerCards.map((data: any, index) => {
          if (data.isDisabled) {
            return null;
          }
          let SubComponent = null;
          if (data.image) {
            SubComponent = <ImageComponent image={data.image} />;
          } else if (data.fileType) {
            SubComponent = <FileTypeComponent />;
          }

          return (
            <Card
              key={index}
              variant="outlined"
              sx={{
                cursor: "pointer",
                width: "100%",
                height: "148px",
                boxShadow:
                  "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.08) 0px 8px 1px -8px",
                borderRadius: "8px",
                transition: "box-shadow 0.3s ease",
                ":hover": {
                  boxShadow: "none",
                },
              }}
              onClick={() => {
                if (index === 0) {
                  setCustomerCreationMethod("manual");
                } else if (index === 1) {
                  setCustomerCreationMethod("bulk");
                }
                setCurrentStep(1);
              }}
            >
              <Stack
                direction={data.image ? "row" : "column"}
                sx={{
                  justifyContent: "space-between",
                  display: "flex",
                  height: "100%",
                  padding: "16px 16px 4px 16px",
                }}
              >
                <Stack>
                  <Typography variant="h6">{data.title}</Typography>
                  <Typography
                    variant="body-medium"
                    color={theme.palette.lightBg.low}
                  >
                    {data.description}
                  </Typography>
                </Stack>
                {SubComponent}
              </Stack>
            </Card>
          );
        })}
      </Stack>
    </Stack>
  );
};
const ImageComponent = ({ image }: { image: string }) => {
  return (
    <Stack
      sx={{
        width: "100px",
        height: "100px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={image}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
        alt="card"
      />
    </Stack>
  );
};

const FileTypeComponent = () => (
  <Stack
    direction="row"
    gap="8px"
    alignSelf="flex-end"
    sx={{ paddingBottom: "12px", marginTop: "auto" }}
  >
    <img
      src={XlsxFileTypeImg}
      alt="XLSX file type"
      width="28px"
      height="32px"
    />
    <img src={CsvFileTypeImg} alt="CSV file type" width="28px" height="32px" />
  </Stack>
);

const customerCards = [
  {
    title: "Add customer manually",
    description: "Enter details and add your customer.",
    image: girlWithBook,
    isDisabled: false,
  },
  {
    title: "Bulk upload customers",
    description: "Upload a .CSV or .XLSX file with customer details.",
    fileType: [
      "text/csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    isDisabled: false,
  },
];
